<template>
    <div class="news-main main bg-gray">
        <div class="htmldiv pb25">
            <div class="bgw br5" v-if="article">
                <Crumb :typeId="article.category_id" :isBack="true" :showTitle="false"></Crumb>
                <div v-if="article" class="notice-detail">
                    <div class="notice-title fs30 tcenter pb30">
                        {{article.title}}
                    </div>
                    <div class="notice-other tcenter mcolor fs16 mb40">
                        <span v-if="article.source" class="ml15 mr15">信息来源：{{article.source}}</span>
                        <span v-if="article.open_time" class="ml15 mr15">发布日期：{{article.open_time}}</span>
                        <span v-if="article.view_count" class="ml15 mr15">点击数：{{article.view_count}}</span>
                    </div>
                    <div class="notice-cont ncont fs16 lh20" v-html="article.content">
                    </div>
                </div>
                <div v-if="articleDownload.length">
                    <div class="fs15 mb5">附件下载</div>
                    <div v-for="item in articleDownload" 
                        :key="item.nm" 
                        @click="downloadFile(item)" 
                        style="margin-bottom: 5px;padding: 0 20px;color: blue;" 
                        class="cpointer">
                        {{ item.nm }}
                    </div>
                </div>
                <div class="notice-prev-after fs16 pb25 pl30 pr30 pt5" v-if="article.pre_article || article.next_article">
                    <router-link v-if="article.pre_article" :to="`${$params.baseDir}news/sdetail/${article.pre_article.id}`" class="dblock h-mcolor mt15" >
                        上一篇：{{article.pre_article.title}}</router-link>
                    <router-link v-if="article.next_article" :to="`${$params.baseDir}news/sdetail/${article.next_article.id}`" class="dblock h-mcolor mt15">
                        下一篇：{{article.next_article.title}}
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Crumb from '@/components/common/Crumb'
export default {
    components: {
        Crumb
    },
    data() {
        return {
            article: {},
            articleId: 0,
            page: 0,
            pageSize: 1,
            articleDownload: []
        }
    },
    watch: {
        $route: {
            //immediate: true,
            deep: true,
            handler: function(nV,oV){
                this.getArticle()
            }
        }
    },
    created() {
        this.getArticle()
    },
    methods: {
        getArticle() {
            let query = {
                id: this.$route.params.id,
                num: this.$route.query.num,
                page: this.$route.query.page,
                size: this.$route.query.pageSize
            }
            this.$request.get('article/detail', query, res => {
                if (res.data.code == 200) {
                    this.article = res.data.data
                    let article = res.data.data
                    var fileArr = []
                    if (article.article_file) {
                        for (var i in article.article_file) {
                            var file = article.article_file[i]
                            var arr = file.split('/')
                            var nm = arr[arr.length - 1].split('.')[0]
                            fileArr[i] = { nm, url: file }
                        }
                    }
                    this.articleDownload = fileArr
                }
            }, err => {
                console.log(err)
            })
        },
        downloadFile(item) {
            // const blob = new Blob([item.url], { type: 'application/pdf' })
            // var el = document.createElement('a')
            // el.download = item.nm
            // el.style.display = 'none'
            // const href = window.URL.createObjectURL(blob)
            // el.href = href
            // document.body.appendChild(el)
            // el.click()
            // document.body.removeChild(el)
            // URL.revokeObjectURL(el.href)
            const link = document.createElement("a"); //自己创建的a标签
            link.href = item.url
            link.download = item.nm
            link.target = "_blank"
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            

        }
    },
}
</script> 
<style scoped>

</style>
